import React from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {privacyNoticeSelect} from '../../redux/selector/privacyNoticeSelector'
import {setPrivacyNoticeAgree} from '../../redux/slice/privacyNoticeSlice'
import {
    Header, 
    Paragraph,
    Button,
    NavigationLinkButton
} from '../../components/RegularComponents'
import { replaceUrlParams } from '../../app/utils';
import { APPLICATION_MODE_RENEW } from '../../app/constants';
import Navigation from '../Navigation';

const PrivacyNotice = (props) => { 
    const{applicationType, applicationMode} = props.match.params
    const privacyNotice = props.privacyNotice[applicationType] ? props.privacyNotice[applicationType] : props.privacyNotice

    const onContinueClick = () => {
        props.dispatch(setPrivacyNoticeAgree())
        if(applicationMode === APPLICATION_MODE_RENEW) {
            props.dispatch(push(replaceUrlParams(privacyNotice.navigationRenewal.next,applicationType,applicationMode)))
        } else {
            props.dispatch(push(replaceUrlParams(privacyNotice.navigation.next,applicationType,applicationMode)))
        }
        
    }
    return (
        <>
        <Navigation {...props} />
        <div className={"container"}>
            <div className="row">
                <div className="col-8">
                    <Header 
                        id="privacy-notice-header"
                        header={privacyNotice.header} />
                    <Paragraph 
                        id="privacy-notice-text"
                        text={privacyNotice.text} />
                </div>
            </div>

            <div className="row">
                <div className="col-lg-8">
                    <Button
                        id="privacy-notice-continue-button" 
                        onClick = {onContinueClick}
                        text={"Continue"} 
                        buttonType={"regular_primary"}
                        style={{marginRight: '20px'}}
                    />
                    <NavigationLinkButton
                        onClick={() => {
                            props.dispatch(push(privacyNotice.navigation.previous))        
                        }}
                        text={"Back"}
                    />
                </div>
            </div>
        </div>
        </>
    )
}
export default connect(privacyNoticeSelect) (PrivacyNotice)
